export default {
  signIn: 'Sign in',
  isSignedIn: 'You are signed in here',
}